import { render, staticRenderFns } from "./LicenseWarningModal.vue?vue&type=template&id=37aa32d0&scoped=true&"
import script from "./LicenseWarningModal.vue?vue&type=script&lang=js&"
export * from "./LicenseWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./LicenseWarningModal.vue?vue&type=style&index=0&id=37aa32d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa32d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37aa32d0')) {
      api.createRecord('37aa32d0', component.options)
    } else {
      api.reload('37aa32d0', component.options)
    }
    module.hot.accept("./LicenseWarningModal.vue?vue&type=template&id=37aa32d0&scoped=true&", function () {
      api.rerender('37aa32d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/LicenseWarningModal.vue"
export default component.exports